import { DateTime } from "luxon";
import { getTimestampFromStr } from "./getTimestampFromStr";

export const checkIfFutureDate = (datestr) => {
  return getTimestampFromStr(datestr) > DateTime.now().toUnixInteger();
};
